import { Typography as MuiTypography } from '@mui/material'
import { styled } from '@mui/material/styles'

export const Title = styled(MuiTypography)(({ theme }) => ({
  textAlign: 'center',
  marginBottom: theme.spacing(3),
  marginTop: theme.spacing(3),

  '&:first-of-type': {
    marginTop: 0,
  },
}))
